import request from '@/utils/request'

/**
 * 申请退货订单
 * @param {Object} data 退货订单信息
 * @returns {Promise}
 */
export function applyReturnStoreCarts(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderCartReturn/applyReturnStoreCarts',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取订单列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrderCartReturn/list',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}